import { AnalyticsScript, SingleToolsBootstrap } from '@quicktools/shared-components';
import initI18n from '@quicktools/shared-components/services/i18n';
import Head from 'next/head';
import React, { useEffect, useCallback } from 'react';
import { useRouter } from 'next/router';
import Script from 'next/script';

import useStore from '../services/store';
import { RECAPTCHA_SITE_KEY } from '../configs';
import translations from '../services/i18n/translation.json';

import type { AppProps } from 'next/app';

initI18n(translations);

function MyApp({ Component, pageProps }: AppProps) {
  const router = useRouter();
  const showValidationError = useStore((state) => state.showValidationError);
  const showGenericError = useStore((state) => state.showGenericError);
  const hideGenericError = useCallback(() => showGenericError(''), []);
  const hideValidationError = useCallback(() => showValidationError(false), []);

  useEffect(() => {
    const handleRouteChange = () => {
      hideGenericError();
      hideValidationError();
    };

    router.events.on('routeChangeStart', handleRouteChange);

    return () => {
      router.events.off('routeChangeStart', handleRouteChange);
    };
  }, [router]);

  return (
    <>
      <Script
        async
        strategy="afterInteractive"
        src="https://securepubads.g.doubleclick.net/tag/js/gpt.js"
      />
      <AnalyticsScript recaptchaSiteKey={RECAPTCHA_SITE_KEY} />

      <Head>
        <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1" />
      </Head>

      <SingleToolsBootstrap>
        <Component {...pageProps} />
      </SingleToolsBootstrap>
    </>
  );
}

export default MyApp;
